import React from 'react'
import { useMediaQuery } from 'react-responsive'
import PageContainer from '../components/PageContainer'
import { partners } from '../util'

const Partners = () => {
    const md = useMediaQuery({ query: '(min-width: 1200px)' })
    
    return (
        <PageContainer>
            <section className="inner-banner parallax-section">
                <div className='overlay'>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 col-sm-12">
                                <h3 className="wow bounceIn" data-wow-delay="0.9s">Our</h3>
                                <h1 className="wow fadeInUp text-uppercase conference mb-05 mt-05" data-wow-delay="1.6s">Partners</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
            {/* <!-- =========================
                OVERVIEW SECTION   
            ============================== --> */}
            <section id="overview" className="parallax-section sponsors">
                <div className="container">
                    <div className="row">
                        {
                            partners.map((partner, key) => (
                                <div key={key} className="wow fadeInUp col-12 col-sm-6 col-md-4 col-lg-3 f-16" data-wow-delay="0.6s">
                                    <img src={process.env.PUBLIC_URL + "assets/images/" + partner.img} className="img-responsive" alt="Overview" style={{ height: '200px', width: '100%', objectFit: 'contain' }} />
                                </div>
                            ))
                        }
                    </div>
                </div>
            </section>

        </PageContainer>

    )
}

export default Partners